import template from "./verify-email-page.html";

const VerifyEmailPageComponent = {
  template: template,
  controller: class VerifyEmailPageController {
    /* @ngInject */
    constructor($rootScope, $state, $stateParams, SecurityManager) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.SecurityManager = SecurityManager;
      this.$stateParams = $stateParams;
    }

    $onInit() {
      const verificationEmailToken = this.$stateParams.token;
      if (!verificationEmailToken) {
        this.loading = false;
      } else {
        this.SecurityManager.verifyEmail(verificationEmailToken)
          .then(() => {
            this.emailVerified = true;
          })
          .catch((error) => {
            this.emailVerified = false;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }

    goLoginPage() {
      this.$state.go("login");
    }
  },
};

export default VerifyEmailPageComponent;
